module.exports = __webpack_public_path__ + "img/Real-Madrid.625a7fda.png";